import axios, { AxiosInstance } from 'axios';

const axiosForBackend: AxiosInstance = axios.create({
  baseURL: '',
  withCredentials: true,
  timeout: 30000,
});

function redirectToLogin(): void {
  // 老板端/陪玩端页面不跳转到管理端登录页
  if (window.location.pathname.startsWith('/boss/')) return;
  if (window.location.pathname.startsWith('/play')) return;
  if (!window.location.pathname.startsWith('/login')) {
    window.location.href = '/login';
  }
}

axiosForBackend.interceptors.request.use((config) => {
  // CSRF token (header x-suda-csrf-token must match cookie suda-csrf-token)
  const csrfToken = (window as any).csrfToken || (document.cookie.match(/(?:^|;\s*)suda-csrf-token=([^;]+)/) || [])[1];
  if (csrfToken) {
    config.headers['x-suda-csrf-token'] = decodeURIComponent(csrfToken);
  }
  try {
    // 若调用方已手动指定 Authorization（如 auto_token 临时令牌），予以保留，不覆盖
    const alreadyAuth = !!config.headers.Authorization;
    // 陪玩端页面：使用 play token（localStorage play-auth）
    if (!alreadyAuth && window.location.pathname.startsWith('/play')) {
      const playRaw = localStorage.getItem('play-auth');
      if (playRaw) {
        const playParsed = JSON.parse(playRaw);
        if (playParsed?.token) {
          config.headers.Authorization = `Bearer ${playParsed.token}`;
          return config;
        }
      }
    }
    // 老板端页面：优先使用 boss token（localStorage boss-auth）
    if (!alreadyAuth && window.location.pathname.startsWith('/boss')) {
      const bossRaw = localStorage.getItem('boss-auth');
      if (bossRaw) {
        const bossParsed = JSON.parse(bossRaw);
        if (bossParsed?.token) {
          config.headers.Authorization = `Bearer ${bossParsed.token}`;
          return config;
        }
      }
    }
    if (!alreadyAuth) {
      const raw = sessionStorage.getItem('studio-auth-storage');
      if (raw) {
        const parsed = JSON.parse(raw);
        const token: string | undefined = parsed.token ?? parsed.state?.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    }
  } catch {
    // ignore parse errors
  }
  return config;
});

axiosForBackend.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl: string = error.config?.url || '';
      const isAppBackendResponse: boolean =
        typeof error.response.data === 'object' && error.response.data !== null;
      if (!requestUrl.includes('/auth/login') && isAppBackendResponse) {
        sessionStorage.removeItem('studio-auth-storage');
        redirectToLogin();
      }
    }
    return Promise.reject(error);
  },
);

export default axiosForBackend;
